import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import PageSection from 'components/PageSection';
import distributedEnergyImg1 from 'assets/images/distributed-energy-1.png';
import distributedEnergyImg2 from 'assets/images/distributed-energy-2.png';
import { Body1, SectionTitle } from 'components/Typography';
import LocalizedLink from 'components/LocalizedLink';
import { paths } from 'constants';

const DistributedEnergy = () => {
    const { t } = useTranslation('product');
    return (
        <PageSection>
            <div className="flex flex-col lg:flex-row gap-8 lg:items-center">
                <div className="flex-1">
                    <SectionTitle className="fade-in-scroll mb-8">{t('distributed.title')}</SectionTitle>
                    <Body1 className="fade-in-scroll mb-4">
                        <Trans i18nKey="product:distributed.body" components={{ 1: <br />, 2: <br /> }} />
                    </Body1>
                </div>

                <div className="flex-1">
                    <div className="w-full overflow-x-scroll lg:overflow-hidden pb-4 lg:pb-0">
                        <div className="flex items-center gap-4 pt-16 w-[160vw] md:w-[120vw] lg:w-full">
                            <div className="lg:flex-1 basis-1/3">
                                <LocalizedLink className="block w-full" to={paths.requestDemo}>
                                    <img
                                        className="fade-in-scroll w-full object-contain"
                                        src={distributedEnergyImg1}
                                        alt=""
                                    />
                                </LocalizedLink>
                            </div>
                            <div className="flex-1 flex lg:flex-col gap-4">
                                <div className="flex-1">
                                    <LocalizedLink className="block w-full" to={paths.requestDemo}>
                                        <img
                                            className="fade-in-scroll w-full object-contain"
                                            src={distributedEnergyImg2}
                                            alt=""
                                        />
                                    </LocalizedLink>
                                </div>
                                <div className="flex-1">
                                    <LocalizedLink className="block w-full" to={paths.requestDemo} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </PageSection>
    );
};

export default DistributedEnergy;
